import { makeStyles } from '../../../../../../../../styles';
export default makeStyles((theme) => ({
    wrapper: {
        display: 'flex',
        textAlign: 'center',
        flexDirection: 'column',
    },
    imageWrapper: {
        marginTop: theme.spacing(7),
    },
    title: {
        fontSize: '16px',
        fontWeight: 600,
        marginTop: theme.spacing(2),
    },
    description: {
        color: theme.colors.gray['700'],
        marginTop: theme.spacing(1),
    },
    button: {
        marginTop: theme.spacing(2),
    },
}));
//# sourceMappingURL=EmptyCustomMetricsScreen.styles.js.map